import './Tile.css'

/**
 * A count, marked only when it is non-zero.
 *
 * In its own module rather than beside Tile: a file exporting both a component
 * and a plain function breaks React Fast Refresh, so editing either would reload
 * the page instead of preserving state. Same reason referenceOptions.ts is
 * separate from the pickers that use it.
 */
export function cell(value: number | undefined, tone: string) {
  if (!value) return <span className="zero">0</span>
  return <span className={`count count--${tone}`}>{value}</span>
}
